import React from "react";
                  
export default function MyPage() {
    return <h1>Hello!</h1>
}   